import React, { useState, useEffect } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { path } from 'ramda'
import { clone } from 'lodash'
import L from '../L'
import Tabs, { HamburgerTabs } from '../Tabs'
import Search from '../Search'
import NavMenu from '../NavMenu'
import AccountActions from '../../Redux/AccountRedux'
import { COLLECTIONS_COLLECTION, SIMULATIONS_COLLECTION } from '../../Config'
import { StyledTabHeader, StyledSearch } from './TabHeader-styles'

const enhance = compose(
  connect(
    ({ firestore: { data, ordered }, account: { searchItems, searchOpen } }) => ({
      searchItems,
      searchOpen,
      collections: path([COLLECTIONS_COLLECTION], ordered),
      simulations: path([SIMULATIONS_COLLECTION], data),
    }),
    dispatch => ({
      setSearch: searchItems => dispatch(AccountActions.AccountSetSearch(searchItems)),
      toggleSearch: isOpen => dispatch(AccountActions.AccountToggleSearch(isOpen)),
    }),
  ),
)

const TabHeader = ({
  collections,
  simulations,
  searchOpen,
  searchItems,
  tabs,
  tab,
  setSearch,
  hideNavMenu,
  toggleSearch,
}) => {
  const [value, setValue] = useState([])
  const [animationState, setAnimationState] = useState('set-off')

  useEffect(() => {
    setValue(clone(searchItems))
  }, [searchItems])

  useEffect(() => {
    let timeout = null
    if (searchOpen) {
      setAnimationState('turn-on')
      timeout = setTimeout(() => setAnimationState('set-on'), 900)
    } else if (animationState !== 'set-off') {
      setAnimationState('turn-off')
      timeout = setTimeout(() => setAnimationState('set-off'), 900)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [searchOpen])

  return (
    <StyledTabHeader searchOpen={searchOpen} animationState={animationState}>
      <L container display="grid" ai="center" jc="space-between" columns="auto 1fr auto" z="header" pX={0}>
        <L>
          <L display={{ md: 'none' }} pL={1.5}>
            <HamburgerTabs tab={tab} tabs={tabs} />
          </L>
          <L display={{ xx: 'none', md: 'block' }}>
            <Tabs tab={tab} tabs={tabs} />
          </L>
        </L>
        <StyledSearch animationState={animationState}>
          <Search
            animationState={animationState}
            value={value}
            collections={collections}
            simulations={simulations}
            remove={['Collections']}
            onChange={(e, items) => {
              setValue(items)
              setSearch(items)
            }}
            onToggle={toggleSearch}
          />
        </StyledSearch>
        {!hideNavMenu && (
          <div>
            <NavMenu />
          </div>
        )}
      </L>
    </StyledTabHeader>
  )
}

export default enhance(TabHeader)
